var permission = '', username = '', userId = '', level = '', department = '';

const server = {
  state: {
    userId: userId,
    permission: permission,
    department: department,
    level: level,
    username: username,
  },
  mutations: {
    USERId: (state, data) => {
    },
    PERMISSION: (state, data) => {
    },
    DERARTMENT: (state, data) => {
    },
    LEVEL: (state, data) => {
    },
    USERNAME: (state, data) => {
    }
  },
  actions: {
    userId({commit}, data) {
      commit("USERId", data);
    },
    permission({commit}, data) {
      commit("PERMISSION", data);
    },
    department({commit}, data) {
      commit("DERARTMENT", data);
    },
    level({commit}, data) {
      commit("LEVEL", data);
    },
    username({commit}, data) {
      commit("USERNAME", data);
    },

  },
  getters: {
    userId: state => {
      return state.userId
    },
    permission: state => {
      return permission
    },
    department: state => {
      return state.department
    },
    level: state => {
      return state.level
    },
    username: state => {
      return state.username
    }
  }
};
export default server;



// WEBPACK FOOTER //
// ./src/store/mutations/server.js